<template>
  <div class="wrapper mt-3">
    <template v-if="userHasAccess">
      <messages-list
        v-if="allDataLoaded"
        :withFilters="true"
        :allCustomers="allCustomers"
        :allInquiries="allInquiries"
        :allAdvisers="allAdvisers" />
      <div
        v-if="!allDataLoaded && !loadError"
        class="loading-spinner-wrapper">
        <div class="loading-spinner pb-3 pt-3">
          <span class="loading-spinner-content">
            {{ $t('ui.loadingDataInProgress') }}&hellip;
          </span>
        </div>
      </div>
      <f-alert
        v-if="loadError"
        visible
        theme="warning">
        <span>
          {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
        </span>
      </f-alert>
    </template>
    <f-alert
      v-else
      visible
      class="my-5"
      theme="inactive">
      <span>
      {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
      </span>
    </f-alert>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import MessagesList from './lists/MessagesList.vue'

export default {
  name: 'messages',
  components: {
    'messages-list': MessagesList
  },
  computed: {
    userHasAccess () {
      return this.$store.getters.getUserHasFeature('communications');
    },
    allDataLoaded () {
      if (!this.userHasAccess) {
        return true;
      }
      if (this.userType === 'adviser') {
        return this.customersLoaded && this.inquiriesLoaded;
      }

      return this.inquiriesLoaded;
    }
  },
  watch: {
    userHasAccess (newValue) {
      if (newValue && !this.viewInitiated) {
        this.loadAdditionalData();
      }
    }
  },
  data() {
    return {
      advisersLoaded: false,
      allAdvisers: [],
      allCustomers: [],
      allInquiries: [],
      customersLoaded: false,
      inquiriesLoaded: false,
      loadError: false,
      userType: null,
      viewInitiated: false
    }
  },
  mounted () {
    this.userType = this.$store.getters['getUserType'].toLowerCase();
    if (this.userHasAccess) {
      this.loadAdditionalData();
    }
  },
  methods: {
    loadAdditionalData () {
      Vue.set(this, 'viewInitiated', true);

      if (this.userType === 'adviser') {
        FormUtils.loadAdditionalData(this, {
          endpoint: '/api/adviser/customers/items',
          method: 'get',
          outputKey: 'allCustomers',
          loadedKey: 'customersLoaded',
          errorKey: 'loadError',
          params: {
            pagination: 0,
            where: { 'has_messages': 1 }
          }
        });
      }

      if (this.userType === 'customer') {
        FormUtils.loadAdditionalData(this, {
          endpoint: '/api/customer/advisers/items',
          method: 'get',
          outputKey: 'allAdvisers',
          loadedKey: 'advisersLoaded',
          errorKey: 'loadError',
          params: {
            pagination: 0,
            where: { 'has_messages': 1 }
          }
        });
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/' + this.userType + '/inquiries/items',
        method: 'get',
        outputKey: 'allInquiries',
        loadedKey: 'inquiriesLoaded',
        errorKey: 'loadError',
        params: {
          pagination: 0,
          where: { 'has_messages': 1 }
        }
      });
    }
  }
};
</script>
